import type { AdminPlugin } from "./types";
import submissionsPlugin from "./submissions";
import applicationsPlugin from "./applications";
import galleryPlugin from "./gallery";
import settingsPlugin from "./settings";

const plugins: AdminPlugin[] = [submissionsPlugin, applicationsPlugin, galleryPlugin, settingsPlugin];

export default plugins;
